
const digest = '8884b5565b151e66c09c3b0115528ac10bae0774fd1a4f20d666984c9127def4';
const classes = {"item":"_item_3tkuu_1","title":"_title_3tkuu_14","requisitions":"_requisitions_3tkuu_19"};
const css = `._item_3tkuu_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 40px 15px 20px;
  border-radius: 6px;
  margin-bottom: 10px;
  background-color: #d8eff8;
}
._item_3tkuu_1:nth-of-type(odd) {
  background-color: #edf7fc;
}
._item_3tkuu_1 ._title_3tkuu_14 {
  font-weight: 500;
  color: #1665d8;
}

._requisitions_3tkuu_19 {
  border: 1px solid #eaedf5;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._requisitions_3tkuu_19 ._item_3tkuu_1 {
  background: #fff;
  margin-bottom: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  